import React from 'react';
import { Box, Container } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const CompanyFooter = () => {
  const theme = useTheme();
  const isDarkMode = true;
  const footerBg = isDarkMode ? '#000' : theme.palette.background.paper;
  const footerText = isDarkMode ? theme.palette.common.white : theme.palette.text.primary;
  const brpLogoFilter = isDarkMode ? 'none' : 'brightness(0)';
  const logoFilter = isDarkMode ? 'brightness(0) invert(1)' : 'none';
  const dividerColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : alpha(theme.palette.common.black, 0.08);
  const brands = [
    { name: 'Ski-Doo', logo: '/images/footer/ski-doo-logo.svg' },
    { name: 'Lynx', logo: '/images/footer/lynx-logo.svg' },
    { name: 'Sea-Doo', logo: '/images/footer/sea-doo-logo.svg' },
    { name: 'Can-Am', logo: '/images/footer/can-am-logo.svg' },
    { name: 'Rotax', logo: '/images/footer/rotax-logo.svg' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: footerBg,
        color: footerText,
        py: 4,
        mt: 0,
        borderTop: `1px solid ${dividerColor}`,
      }}>
      <Container maxWidth="lg">
        {/* BRP Logo */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 4,
            mt: 4,
          }}>
          <img
            src="/images/BRP-Digital_and_Campaign_Logo-W-RGB.svg"
            alt="BRP"
            style={{
              height: 100,
              width: 100,
              filter: brpLogoFilter,
            }}
          />
        </Box>

        {/* Brand Logos */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 3, sm: 4, md: 6 },
            flexWrap: 'wrap',
            mb: 3,
            mt: 8,
            px: 2,
          }}>
          {brands.map(brand => (
            <Box
              key={brand.name}
              sx={{
                height: { xs: 24, sm: 30 },
                display: 'flex',
                alignItems: 'center',
                opacity: 1,
              }}>
              <img
                src={brand.logo}
                alt={brand.name}
                style={{
                  height: '100%',
                  width: 'auto',
                  filter: logoFilter,
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default CompanyFooter;
